import DownloadService from "../Services/DownloadService";

export const GetDownloadLogs = async (data) => {
  let response = DownloadService.GetDownloadLogs(data);
  return response;
}